
export class InstitutionType {
  public static HOSPITAL = 1;
  public static SCHOOL_DISTRICT = 2;
  public static AFTER_HOUR_CARE = 18;
}
